<div [class]="wrapperClass + ' text-start'">
  <label [for]="id + '_input'">
    {{ label }}
    @if ((controlIsRequired$ | async) && showRequiredStar) {
      <em class="text-danger">*</em>
    }
  </label>
  <div class="input-group">
    <!-- [autofocus]="false" is not the default it looks like (#6079). PrimeNG's AutoFocus directive
         removes the input's autofocus attribute only for an explicit false and sets it otherwise, so
         an unset input left autofocus="true" on every date field. On a fresh page load the browser
         then focused the first one, and the focus opened the calendar over the fields below it. -->
    <p-date-picker #calendar
                   [autofocus]="false"
                   [appendTo]="appendTo"
                   (onSelect)="setValue()"
                   (onClearClick)="control.setValue(null)"
                   [(ngModel)]="value"
                   [dateFormat]="dateFormat"
                   [disabledDays]="disabledDays"
                   [id]="id + '_input'"
                   [inputStyleClass]="control.invalid && control.touched ? 'ng-invalid ng-touched' : ''"
                   [inputStyle]="{width: 'calc(100% - 33px)'}"
                   [view]="view"
                   [readonlyInput]="readonlyInput"
                   [placeholder]="placeholder ?? ''"
                   [showIcon]="true"
                   [showButtonBar]="true"
                   [showTime]="showTime"
                   [style]="{width: '100%'}"
                   [minDate]="minDate"
                   [maxDate]="maxDate"
                   icon="fa fa-calendar">
      @if (calendar.showTime) {
        <ng-template #footer>
          <div class="row">
            <div class="col-12 text-center mb-3">
              <button (click)="calendar.hideOverlay()" class="btn btn-primary">
                Bestätigen
              </button>
            </div>
          </div>
        </ng-template>
      }
    </p-date-picker>
    <input-error-output [control]="control"></input-error-output>
  </div>
</div>
